//
import Image from '../../image';
//
import { CustomFile } from '../types';

type Props = {
  file: CustomFile | string | null;
  widthOffset?: string;
  heightOffset?: string;
};

export function AvatarPreview({
  file,
  widthOffset = '0px',
  heightOffset = '0px',
}: Props) {
  if (!file) {
    return null;
  }

  const imgUrl = typeof file === 'string' ? file : file.preview;

  return (
    <Image
      alt="avatar"
      src={imgUrl}
      sx={{
        zIndex: 8,
        position: 'absolute',
        width: `calc(100% - ${widthOffset})`,
        height: `calc(100% - ${heightOffset})`,
        objectFit: 'cover',
      }}
    />
  );
}

export default AvatarPreview;
